import React, { Component } from 'react';
import { EndPoints } from '../../constants/api-config';
import * as R from 'ramda';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

import logo_default from './../../assets/images/brand/assista_horizontal.svg';

export const Navbar = ({ partnerId, partnerColor }) => {
    let SERVER_ADDR_V1 = EndPoints.backendHost;

    let logo = logo_default;
    if (!R.isNil(partnerId)) {
        logo = `${SERVER_ADDR_V1}/partners/${partnerId}/logo`;
    }
    return (
        <header className="masthead mb-auto text-center py-sm py-lg-gutter">
            <div className="container-fluid cover-container justify-content-center align-items-center d-md-flex">
                <img className={"img-fluid mb-0" + (partnerId ? " rounded-sm img-avatar w-auto" : "")} width="150" src={logo} alt="Assist@" onError={(ev) => ev.target.src = logo_default} />
            </div>
        </header>
    );
};